import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const TechnicalSupport = () => {
  const faqs = [
    {
      question: "Q: Does Docgen offer customer support for users ?",
      answer:
        "A: Docgen offers 24/7 support through product@trexoglobal.com and addresses any issues or questions you might have.",
    },
    {
      question: "Q: What happens if I encounter an error ?",
      answer:
        "A: Docgen's built-in error handling resolves most issues automatically. If a problem persists, please email product@trexoglobal.com and our product support team will assist promptly.",
    },
  ];

  return (
    <Box>
      {faqs.map((faq, i) => (
        <Accordion
          key={i}
          defaultExpanded={i === 0}
          sx={{
            backgroundColor: "#fff",
            "&.Mui-expanded": {
              margin: 0,
            },
            borderBottom: "1px solid #e0e0e0",
          }}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="body2" fontWeight="bold">
              {faq.question}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography sx={{ whiteSpace: "pre-line" }}>
              {faq.answer}
            </Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
};

export default TechnicalSupport;
